var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mt-1"},[_c('v-col',{attrs:{"cols":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('v-col',{attrs:{"cols":"12"},domProps:{"innerHTML":_vm._s(_vm.body)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }